import { FormType } from "@/enums";

export const getFormName = (formType) => {
  const formTypeKey = Object.keys(FormType).find(
    (key) => FormType[key].toLowerCase() === formType
  );

  return FormType[formTypeKey];
};
